import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";

import { AppLayout } from "./components/AppLayout";
import TrackerPage from "./pages/TrackerPage";
import ReportPage from "./pages/ReportPage";
import CarePage from "./pages/CarePage";
import CommunityPage from "./pages/CommunityPage";
import { NIP19Page } from "./pages/NIP19Page";
import NotFound from "./pages/NotFound";

export function AppRouter() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route element={<AppLayout />}>
          <Route path="/" element={<TrackerPage />} />
          <Route path="/report" element={<ReportPage />} />
          <Route path="/care" element={<CarePage />} />
          <Route path="/community" element={<CommunityPage />} />
        </Route>
        {/* NIP-19 route for npub1, note1, naddr1, nevent1, nprofile1 */}
        <Route path="/:nip19" element={<NIP19Page />} />
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
export default AppRouter;
